export const ADMIN_ROUTE = '/admin'
export const ANALYTICS_ROUTE = '/analytics'
export const AUTH_ROUTE = '/auth'
export const DASHBOARD_ROUTE = ':id'
export const THINGS_ROUTE = '/things'
export const OTHER_ROUTE = '*'
export const MAIN_ROUTE = '/'
